import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  SR_HITLIST_STATUS_CREATED,
  SR_HITLIST_STATUS_STARTED,
  SR_HITLIST_STATUS_COMPLETED,
  SR_HITLIST_TASK_TYPE_TO_LABEL_MAPPING,
} from 'common/hitlistTaskConstants';

import { formatPhoneNumber } from 'common/formatters';

import { makeListingAddressStreetDisplay } from 'common/listingHelpers';

import firstWord from 'common/util/firstWord';

import ButtonDeprecated, {
  BUTTON_THEME_GREEN_ADOBE,
  BUTTON_THEME_GREY_ADOBE,
  BUTTON_THEME_YELLOW_GREYCLIFF,
} from 'client/components/ButtonDeprecated';
import SrLink from 'client/components/SrLink/SrLink';

import './HitlistTaskListRow.less';

const getButtonProps = ({ hitlistTask, assignedUser, isAssignedUser }) => {
  switch (hitlistTask.status) {
    case SR_HITLIST_STATUS_CREATED:
    case SR_HITLIST_STATUS_COMPLETED:
      return {
        theme: BUTTON_THEME_GREEN_ADOBE,
        children: 'Start',
      };
    case SR_HITLIST_STATUS_STARTED:
      return {
        theme: isAssignedUser ? BUTTON_THEME_YELLOW_GREYCLIFF : BUTTON_THEME_GREY_ADOBE,
        children: isAssignedUser ? 'Done' : firstWord(assignedUser?.name),
      };
  }
};

const HitlistTaskListRowHeader = ({
  hitlistTask,
  renter,
  listing,
  partner,
  assignedUser,
  isAssignedUser,
  onButtonClick,
}) => {
  return (
    <>
      <div styleName="action">
        <ButtonDeprecated
          onClick={() => onButtonClick({ hitlistTask })}
          className="hitlist"
          {...getButtonProps({
            hitlistTask,
            assignedUser,
            isAssignedUser,
          })}
        />
      </div>
      <div styleName="description">
        <span styleName="renterName">{renter.name}</span>
        <span styleName="renterPhone">{formatPhoneNumber(renter.phone)}</span>
        <span styleName="date">
          {moment(hitlistTask.actionCompletedAt).calendar(null, {
            sameDay: '[Today] [at] h:mm A',
            lastDay: '[Yesterday] [at] h:mm A',
            lastWeek: 'dddd [at] h:mm A',
            sameElse: 'dddd [at] h:mm A',
          })}
          :
        </span>
        <span styleName="type">{SR_HITLIST_TASK_TYPE_TO_LABEL_MAPPING[hitlistTask.type]}</span>
        <SrLink to={`/listing/${listing.id}`} target="_blank" styleName="listingLink">
          {makeListingAddressStreetDisplay(listing)}
          {` ${listing.addressCity}, ${listing.addressStateCode}`}
        </SrLink>
      </div>
      <div styleName="partner">
        <SrLink
          to={`/partner/${partner.slug}/listing/${listing.id}`}
          target="_blank"
          styleName="partnerLink"
        >
          {partner.displayName}
        </SrLink>
      </div>
    </>
  );
};

HitlistTaskListRowHeader.propTypes = {
  hitlistTask: PropTypes.object.isRequired,
  renter: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  partner: PropTypes.object.isRequired,
  assignedUser: PropTypes.object,
  isAssignedUser: PropTypes.bool.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

HitlistTaskListRowHeader.displayName = 'HitlistTaskListRowHeader';

export default HitlistTaskListRowHeader;
